<template>
    <span class="display-flex align-items-center" style="height: 20px;">
        <img v-if="countryCode" class="border-radius-s" :src="flagSource" :title="flagCountryName"
             style="width: 20px;"/>
        <div v-else class="payment-instrument-card-no-country"></div>
    </span>
</template>

<script>
    import COUNTRIES from '@/data/countries';

    export default {
        name: 'v-flags',
        props: {
            countryCode: {
                type: String,
            },
        },
        computed: {
            flagSource() {
                if (this.countryCode) {
                    return `/static/icons/country-flags/${this.countryCode.toLowerCase()}.svg`;
                }
                return null;
            },
            flagCountryName() {
                if (this.countryCode) {
                    const {countryName} = COUNTRIES
                        .find(item => item.countryCode === this.countryCode.toUpperCase());
                    return countryName;
                }
                return null;
            },
        },
    };
</script>
